// extracted by mini-css-extract-plugin
export var content = "_p6-1";
export var fullScreen = "_p6-0";